export default __webpack_public_path__ + "static/avatar-mp-kayi-male-0-v2-cover-2a15261e607bc20213be22f51ca12bcb.png";